var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-4-modify-goals',{attrs:{"section":7,"page":9}},[_vm._v("\n    Now that you have learned about assertive communication and practiced a bit, let’s revisit your goals.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }